var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7171 1.70119L4.98732 8.70075C4.61261 9.09042 4.01313 9.09042 3.63842 8.70075L0.281032 5.17848C-0.0936772 4.78881 -0.0936772 4.15933 0.281032 3.76955C0.655741 3.37988 1.25522 3.37988 1.62993 3.76955L4.32784 6.58736L10.3831 0.292253C10.7578 -0.0974176 11.3573 -0.0974176 11.732 0.292253C12.0918 0.681923 12.0918 1.31151 11.7171 1.70119H11.7171Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selected.561cbecf6c89d8e48bba93cc35039d4c.svg";